export enum ColorSchemeFormatterBlock {
  Root = 'ColorSchemeFormatter',
}
